import { createRef, createElement, Component } from 'react';
import MagicGrid__default from 'magic-grid';
export * from 'magic-grid';
import ReactResizeDetector from 'react-resize-detector';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var RevokableMagicGrid = /** @class */ (function (_super) {
    __extends(RevokableMagicGrid, _super);
    function RevokableMagicGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RevokableMagicGrid.prototype.revoke = function () { };
    RevokableMagicGrid.prototype.listen = function () {
        var _this = this;
        if (this.ready()) {
            var revokeTimeout_1;
            // @ts-ignore
            var positionHandler_1 = function () {
                if (!revokeTimeout_1) {
                    revokeTimeout_1 = setTimeout(function () {
                        _this.positionItems();
                        revokeTimeout_1 = null;
                    }, 200);
                }
            };
            window.addEventListener("resize", positionHandler_1);
            this.revoke = function () {
                window.removeEventListener('resize', positionHandler_1);
                if (revokeTimeout_1) {
                    revokeTimeout_1();
                }
                _this.revoke = function () { };
            };
            this.positionItems();
        }
        // @ts-ignore
        else
            this.getReady();
    };
    return RevokableMagicGrid;
}(MagicGrid__default));
var MagicGridComponent = /** @class */ (function (_super) {
    __extends(MagicGridComponent, _super);
    function MagicGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapperRef = createRef();
        _this.componentDidMount = _this.recreateInstance;
        _this.componentWillUnmount = _this.revokeInstance;
        _this.positionItems = function () {
            console.log('gonna reposition');
            if (_this.gridInstance) {
                _this.gridInstance.positionItems();
            }
        };
        return _this;
    }
    MagicGridComponent.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.children !== prevProps.children && this.gridInstance) {
            this.positionItems();
        }
        else if (this.props !== prevProps) {
            this.recreateInstance();
            return;
        }
    };
    MagicGridComponent.prototype.revokeInstance = function () {
        if (this.gridInstance) {
            this.gridInstance.revoke();
            this.gridInstance = undefined;
        }
    };
    MagicGridComponent.prototype.recreateInstance = function () {
        var _this = this;
        if (this.wrapperRef.current) {
            this.revokeInstance();
            var _a = __assign({ container: this.wrapperRef.current, items: (!this.props.static && this.props.children) ? [].concat(this.props.children).length : undefined }, this.props), children = _a.children, config = __rest(_a, ["children"]);
            if (config.static || (config.items && config.items > 0)) {
                try {
                    this.gridInstance = new RevokableMagicGrid(config);
                    setTimeout(function () {
                        if (_this.gridInstance) {
                            _this.gridInstance.positionItems();
                        }
                    }, 500);
                    this.gridInstance.listen();
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    };
    MagicGridComponent.prototype.render = function () {
        var _this = this;
        return (createElement(ReactResizeDetector, { render: function () {
                _this.positionItems();
                return (createElement("div", { ref: _this.wrapperRef, className: "magic-grid", style: { width: '100%' } }, _this.props.children));
            }, handleWidth: true, skipOnMount: true }));
    };
    return MagicGridComponent;
}(Component));
// @ts-ignore
MagicGridComponent.defaultProps = {
    gutter: 32,
    maxCols: 5,
    maxColWidth: 280,
    useMin: false,
    animate: false
};

export default MagicGridComponent;
//# sourceMappingURL=magic-grid-react.es.js.map
